import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const SET_OFFER_STATUS_MUTATION = gql`
  mutation setOfferStatus(
    $documentVersion: DocumentVersionInput!
    $status: String!
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        setStatusAsString(status: $status) {
          revision
          status
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SetOfferStatusMutation extends Mutation<RootMutation> {
  document = SET_OFFER_STATUS_MUTATION;
}
